import { genbankToJson } from 'genbank-parser';
import { getBasename, getFilename, getTargetProperty, getTextContent, } from "../common.js";
const genbank = {
    find(entries, filename) {
        const reference = getBasename(filename);
        return entries.find((entry) => {
            return getBasename(getFilename(entry) ?? '') === reference;
        });
    },
    getProperty(filename) {
        return getTargetProperty(filename);
    },
    process(filename, content) {
        const textContent = getTextContent(content);
        const parsed = genbankToJson(textContent);
        return {
            seq: parsed,
        };
    },
    jpath: ['biology', 'nucleic'],
};
export default genbank;
//# sourceMappingURL=genbank.js.map